import React, { createContext, useContext, ReactNode } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
import { WebSocketMessage, UseWebSocketReturn } from '../types/websocket';

interface WebSocketContextType extends UseWebSocketReturn {
  tenantId: string;
  userId: number;
}

interface WebSocketProviderProps {
  children: ReactNode;
  tenantId: string;
  userId: number;
  token: string;
  onMessage?: (message: WebSocketMessage) => void;
  onConnect?: () => void;
  onDisconnect?: () => void;
  onError?: (error: Event) => void;
}

const WebSocketContext = createContext<WebSocketContextType | null>(null);

export const WebSocketProvider: React.FC<WebSocketProviderProps> = ({ 
  children, 
  tenantId, 
  userId, 
  token,
  onMessage,
  onConnect,
  onDisconnect,
  onError
}) => {
  const webSocket = useWebSocket(tenantId, userId, token, {
    onMessage,
    onConnect,
    onDisconnect,
    onError
  });

  const contextValue: WebSocketContextType = {
    ...webSocket,
    tenantId,
    userId
  };

  return (
    <WebSocketContext.Provider value={contextValue}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = (): WebSocketContextType => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocketContext must be used within a WebSocketProvider');
  }
  return context;
};
